var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Take-Picture",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,11 C18.5128358,11 18.9355072,11.3860402 18.9932723,11.8833789 L19,12 L19,16 C19,17.5976809 17.75108,18.9036609 16.1762728,18.9949073 L16,19 L2,19 C0.402319117,19 -0.903660879,17.75108 -0.994907307,16.1762728 L-1,16 L-1,12 C-1,11.4477153 -0.55228475,11 0,11 C0.512835839,11 0.935507161,11.3860402 0.993272269,11.8833789 L1,12 L1,16 C1,16.5128358 1.38604019,16.9355072 1.88337887,16.9932723 L2,17 L16,17 C16.5128358,17 16.9355072,16.6139598 16.9932723,16.1166211 L17,16 L17,12 C17,11.4477153 17.4477153,11 18,11 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29289322,-0.707106781 C8.65337718,-1.06759074 9.22060824,-1.09532028 9.61289944,-0.790295388 L9.70710678,-0.707106781 L14.7071068,4.29289322 C15.0976311,4.68341751 15.0976311,5.31658249 14.7071068,5.70710678 C14.3466228,6.06759074 13.7793918,6.09532028 13.3871006,5.79029539 L13.2928932,5.70710678 L9,1.415 L4.70710678,5.70710678 C4.34662282,6.06759074 3.77939176,6.09532028 3.38710056,5.79029539 L3.29289322,5.70710678 C2.93240926,5.34662282 2.90467972,4.77939176 3.20970461,4.38710056 L3.29289322,4.29289322 L8.29289322,-0.707106781 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,-1 C9.51283584,-1 9.93550716,-0.61395981 9.99327227,-0.116621125 L10,0 L10,12 C10,12.5522847 9.55228475,13 9,13 C8.48716416,13 8.06449284,12.6139598 8.00672773,12.1166211 L8,12 L8,0 C8,-0.55228475 8.44771525,-1 9,-1 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/Add File.cf71d4019e6211090b836db5261d5b48.svg";
export { ForwardRef as ReactComponent };